import { useEffect, useMemo, useState } from 'react'

function useOutsideClick(ref, eventType = 'mousedown') {
  const [isClickOutside, setClickOutside] = useState(true)

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref?.current && !ref?.current.contains(event.target)) {
        return setClickOutside(true)
      }
      return setClickOutside(false)
    }
    // Bind the event listener
    document.addEventListener(eventType, handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(eventType, handleClickOutside)
    }
  }, [ref, eventType])

  return useMemo(() => ({ isClickOutside, setClickOutside }), [isClickOutside])
}

export default useOutsideClick
